import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router';

import {
  blogCategoriesQueryOptions,
  blogPostListParams,
  blogPostListQueryOptions,
  blogPostListSearchSchema,
  BlogPostsPage,
} from '@/features/blog';

export const Route = createFileRoute('/_authed/_active/s/$storeId/content/blog/')({
  staticData: { tours: ['content.blog'] },
  // Typed as the raw input so links into the list (`<Link to=".../content/blog">`) need no search.
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput) =>
    blogPostListSearchSchema.parse(search),
  loaderDeps: ({ search }) => search,
  loader: async ({ context, params, deps, cause }) => {
    const prefetch = Promise.all([
      context.queryClient
        .query({
          ...blogPostListQueryOptions(params.storeId, blogPostListParams(deps)),
          staleTime: 'static',
        })
        .catch(() => undefined),
      context.queryClient
        .query({ ...blogCategoriesQueryOptions(params.storeId), staleTime: 'static' })
        .catch(() => undefined),
    ]);
    // Filter, sort and page changes on the list must not wait for the fetch, or a second pick in
    // the filter would build on the stale URL. The page's own query shows the previous rows.
    if (cause !== 'stay') await prefetch;
  },
  component: BlogPostsPage,
});
